export default __webpack_public_path__ + "static/media/northamerica.c06cd0ec.png";